import React, { useEffect, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import Loader from "./Loader";

const SignatureModal = ({
  isOpen,
  onClose,
  isSavingSignature,
  signatureRef,
  clearSignature,
  onSave,
  onUpload,
}) => {
  const [file, setFile] = useState(null);
  const [isFileError, setIsFileError] = useState(false);
  const [errorMessage, setErrorMessage] = useState([]);

  const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
  const MAX_FILE_SIZE = 2;

  const handleFileChange = (e) => {
    const isSignEmpty = signatureRef?.current?.isEmpty();
    const file = e.target.files[0];
    if (!file || !isSignEmpty) {
      e.target.value = "";
      return;
    }

    const isAllowedType = allowedTypes.includes(file.type);
    const isAllowedSize = file.size / 1024 / 1024 <= MAX_FILE_SIZE;

    const error = ["Please upload a valid file."];

    if (!isAllowedType) error.push("Allowed file types: .png, .jpg, .jpeg.");
    if (!isAllowedSize) error.push(`Maximum file size: ${MAX_FILE_SIZE}MB.`);

    if (!isAllowedType || !isAllowedSize) {
      setErrorMessage(error);
      setIsFileError(true);
      return;
    }

    setFile(file);
  };

  const handleOnSave = () => {
    if (file) return onUpload(file);

    const isSignEmpty = signatureRef?.current?.isEmpty();
    if (isSignEmpty) {
      setErrorMessage(["Signature is required."]);
      setIsFileError(true);
      return;
    }

    onSave();
  };

  useEffect(() => {
    if (!isOpen) {
      setFile(null);
      setIsFileError(false);
      setErrorMessage([]);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="ps-modal-overlay">
      <div className="ps-modal">
        <h3 className="ps-heading ps-modal-title">Add Your Signature</h3>

        {isSavingSignature ? (
          <Loader size="medium" text="Saving signature..." />
        ) : (
          <div className="ps-modal-body">
            <div className="ps-signature-block">
              <div className="ps-signature-canvas-wrapper">
                <SignatureCanvas
                  ref={signatureRef}
                  canvasProps={{
                    style: {
                      width: "100%",
                      height: "100%",
                    },
                  }}
                />
              </div>
              <button className="ps-toolbar-btn" onClick={clearSignature}>
                Clear
              </button>
            </div>

            <div className="ps-upload-section">
              <p className="ps-upload-label">Or upload signature image:</p>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e)}
                className="ps-upload-input"
              />
              {isFileError && errorMessage?.length ? (
                <div>
                  {errorMessage?.map((error, index) => (
                    <p key={index} className="error">
                      {error}
                    </p>
                  ))}
                </div>
              ) : null}
            </div>

            <div className="ps-modal-actions">
              <button className="ps-button red" onClick={onClose}>
                Cancel
              </button>
              <button
                className="ps-button blue"
                onClick={handleOnSave}
                disabled={isSavingSignature}
              >
                Save Signature
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SignatureModal;
